import { render, staticRenderFns } from "./PhysicianViewPhysicianInfoCard.vue?vue&type=template&id=35fdc2b4&"
import script from "./PhysicianViewPhysicianInfoCard.vue?vue&type=script&lang=js&"
export * from "./PhysicianViewPhysicianInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports